import z from "zod";

const grooveErrorTypeValues = ["MISSING_API_KEY", "API_REQUEST_FAILED"] as const;

const grooveErrorTypeSchema = z.enum(grooveErrorTypeValues);
export const GrooveErrorType = grooveErrorTypeSchema.enum;
export type GrooveErrorType = z.infer<typeof grooveErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GrooveErrors =
  | {
      errorType: typeof GrooveErrorType.MISSING_API_KEY;
      data: undefined;
    }
  | {
      errorType: typeof GrooveErrorType.API_REQUEST_FAILED;
      data: {
        path: string;
        status?: number;
        detail?: string;
      };
    };

export const grooveErrorDetails: Record<GrooveErrorType, ErrorDetails> = {
  MISSING_API_KEY: {
    sentryDescription: "GROOVE_API_KEY is not configured in the environment",
  },
  API_REQUEST_FAILED: {
    sentryDescription: "Groove API request failed",
  },
};
